import React, { useState, useEffect } from 'react';
import { useLocation,useSearchParams,useNavigate, Link } from 'react-router-dom';
import { Form, Button, Alert} from 'react-bootstrap';
import { postData } from '../ApiServices/ApiService';
import ClipboardJS from 'clipboard';

import { Box, Typography, Slider } from '@mui/material';
import NavHeader from './NavHeader';


const GenerateLink = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedTechnologies = location.state?.selectedTechnologies || [];

  const [formData, setFormData] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const job_id = searchParams.get('id');
  const company_id = searchParams.get('cid')
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
  const [linkData, setLinkData] = useState('');
  const [total, setTotal]=useState(0);
  const [testId,setTestId]=useState('');
  const [candidatePageFlag,setCandidatePageFlag]=useState(false);
  const updateState = location.state?.updateState || 0;

  const handleInputChange = (tech,property, value) => {
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [tech]:value,
    // }));
    // setError('');
    setFormData((prevFormData) => ({
      ...prevFormData,
      [tech]: {
        ...prevFormData[tech],
        [property]: value,
      },
    }));
  };

  useEffect(() => {
    const initialFormData = {};
    if (selectedTechnologies.length === 0) {
      return;
    }
    selectedTechnologies.forEach((tech) => {
      initialFormData[tech] = {
        questions: 1,
        tech_level: 'intermediate',
      };
    });
    setFormData(initialFormData);
    setTotal(selectedTechnologies.length);
  }, [selectedTechnologies]);
  
  useEffect(() => {
    // setTotal(Object.values(formData).reduce((a, b) => a + (Number(b) || 0), 0));
    if (selectedTechnologies.length === 0) {
      return;
    }
    setTotal(
      selectedTechnologies.reduce((acc, tech) => {
        const value = formData[tech]?.questions || 0;
        return acc + parseInt(value, 10);
      }, 0)
    );
  }, [formData,selectedTechnologies]);
  
  const handleSubmit = async () => {
    for (const tech of selectedTechnologies) {
      // const value = formData[tech];
      const questions = formData[tech]?.questions;

      // Check if the value is empty or less than 1
      if (!questions || parseInt(questions, 10) < 1) {
        setError(`Enter a valid value for ${tech} (minimum: 1).`);
        return false;
      }
    }
    const sum = Object.values(formData).reduce((acc, value) => acc + parseInt(value, 10) || 0, 0);
    if (sum > 10) {
      setError('Sum of all input values must be less than or equal to 10.');
      return false;
    }

     try {        
        setLoading(true);
        setError('');
        var payload ={}
        if(updateState === "1"){
          if(selectedTechnologies.length > 0){
            payload = {
              "op": "update_tech_q_count",
              "technologies": formData,
              "company_id": company_id,
              "user_id": aminInfo.user_id,
              "job_id": job_id,
            }
          }
          postData('admin_in/job/update-job-details', payload).then(resp => {
            resp.json().then(respData => {
              if (resp.status === 200) {
                if (respData.statusCode === 200) {
                  if (respData.message.toLowerCase() === 'success') {
                    setLoading(false);
                    setSuccess(respData.info);
                    // setTestId( respData.dataJ.test_id)
                    // let link = respData.dataJ.link +'users-test?id='+ respData.dataJ.test_id;
                    setCandidatePageFlag(true);
                   
                  } else {
                    setLoading(false);
                    console.log('resp else s : ', resp.info);
                  }
                } else if(respData.statusCode === 500){
                  setError(respData.info);
                  setLoading(false);
                }else{
                  setLoading(false);
                  setError('Network Error');
                }
              } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
                setLoading(false);
                if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                  || respData.message === 'Access Denied') {
                    setLoading(false)
                //   callRefreshTokenApi('getSfeBatch', '');
                }
                setSuccess('Looks Like Session Expired Please login..');
              }else {
                setLoading(false);
                console.log('resp status else  : ', resp);
              }
            }).catch((error) => {
              setLoading(false);
              console.log('network error:', error);
            });
          }).catch((error) => {
            setLoading(false);
            console.log('network error:', error);
          });

        }else{
          if(selectedTechnologies.length > 0){
            payload = {
              "op": "update_count_ai_questions_generate_link",
              "technologies": formData,
              "company_id": company_id,
              "user_id": aminInfo.user_id,
              "job_id": job_id,
            }
          }
          postData('admin_in/test_input_one', payload).then(resp => {
            resp.json().then(respData => {
              if (resp.status === 200) {
                if (respData.statusCode === 200) {
                  if (respData.message.toLowerCase() === 'success') {
                    setLoading(false);
                    setSuccess(respData.info);
                    setTestId( respData.dataJ.test_id)
                    let link = respData.dataJ.link +'users-test?id='+ respData.dataJ.test_id;
                    setCandidatePageFlag(true);
                    setLinkData(link);
              
                  } else {
                    setLoading(false);
                    console.log('resp else s : ', resp.info);
                  }
                } else if(respData.statusCode === 500){
                  setError(respData.info);
                  setLoading(false);
                }else{
                  setLoading(false);
                  setError('Network Error');
                }
              } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
                setLoading(false);
                if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                  || respData.message === 'Access Denied') {
                    setLoading(false)
                //   callRefreshTokenApi('getSfeBatch', '');
                }
                setSuccess('Looks Like Session Expired Please login..');
              }else {
                setLoading(false);
                console.log('resp status else  : ', resp);
              }
            }).catch((error) => {
              setLoading(false);
              console.log('network error:', error);
            });
          }).catch((error) => {
            setLoading(false);
            console.log('network error:', error);
          });
        }
        
        // return
       
        
      } catch (error) {
        setLoading(false);
        console.error('Error sending data:', error);
      }
  };

  const [buttonText, setButtonText] = useState('Copy');

  const handleCopy = () => {
    const clipboard = new ClipboardJS('.copy-button', {
      text: function () {
        return linkData;
      },
    });

    clipboard.on('success', () => {
      setButtonText('copied')
      clipboard.destroy();
    });

    clipboard.on('error', () => {
      alert('Failed to copy link to clipboard!');
      clipboard.destroy();
    });
  };

  return (
    < div className='dashboard-div'>
    <NavHeader></NavHeader>
    <div className='link-div'>
    <div className='add-question-div'>
      <Form>
      {selectedTechnologies.map((tech) => (
        <Box key={tech} sx={{ margin: '15px 0' }} className='qns-box'>
          <div>
          <Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: '1' }}>{tech} Questions : {formData[tech]?.questions || 0} </div>
            <div style={{ marginLeft: '15px' }}>
            {/* <legend className="scheduler-border-ing">
            <div className="legend-content" >Test Level:</div> 
        </legend> */}
                <Form.Select size="sm"
                  label="Tech Level"
                  value={formData[tech]?.tech_level || 'Beginner'}
                  onChange={(e) => handleInputChange(tech,'tech_level',e.target.value)}
                >
                 <option value="beginner">Beginner </option>
                  <option value="intermediate">Intermediate</option>
                  <option value="experienced">Experienced</option>
                </Form.Select>
              </div>
            </div>
          </Typography>
          <Slider
            defaultValue={1}
            valueLabelDisplay="auto"
            step={1}
            marks
            min={1}
            max={Math.min(10 - total + (formData[tech]?.questions || 0), 10)}
            onChangeCommitted={(e, value) => handleInputChange(tech,'questions', value)}
            sx={{
              height: 8, // Set the slider line height
              '& .MuiSlider-mark': {
                width: 6,
                height: 6,
                borderRadius: 3,
              },
              '& .MuiSlider-track': {
                height: 8,
              },
            }}
          />
          </div>
     
        </Box>
      ))}
      {selectedTechnologies.length > 0 && <div>Select up to {10 - total} more questions.</div>}      

      {error && <Alert variant="danger" className='m-top'>{error}</Alert>}
      {success ? <Alert variant="success" className='m-top'>{success}</Alert> :   <Button variant="dark" className='m-top' onClick={!loading ? handleSubmit : null }  disabled={loading}>
        {loading ? 'Generating Job....' : ' Submit'}
      </Button>}
    {candidatePageFlag &&(<>
      <Button variant="dark" className='m-top' style={{marginLeft:'5px'}}>
       <Link to={`/job-post`} style={{textDecoration:'none',color:'#fff'}}>Go to Jobs page</Link>
      </Button>
      </>)}
      {/* {loading && (
        <div className="spinner-overlay">
          <Spinner animation="border" role="status">
            <span className="sr-only"></span>
          </Spinner>
        </div>
      )} */}
    </Form>

      {/* {linkData && (
         <div className='m-top' style={{ display: 'flex' }}>
         <Form.Group style={{ width: '100%' }}>
           <Form.Control
             value={linkData}
             aria-label="Generated Link"
             aria-describedby="generated-link"
             readOnly
             style={{ background: 'white' }}
           />
         </Form.Group>
         <Button variant="dark" className="copy-button" onClick={handleCopy}>
           {buttonText}
         </Button>
       </div>
      )} */}
         
    </div>
    </div>
    </div>
  );
};

export default GenerateLink;
